<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" [attr.aria-label]="'USER_MENU.OPEN_MENU' | transloco">
  <span class="relative">
    @if (showAvatar && user?.avatar) {
      <img class="h-7 w-7 rounded-full" [src]="user?.avatar" [attr.alt]="'USER_MENU.AVATAR_ALT' | transloco" />
    }

    @if (!showAvatar || !user?.avatar) {
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
  </span>
</button>

<mat-menu class="user-actions-menu" [xPosition]="'before'" #userActions="matMenu">
  <!-- Non-clickable header row -->
  <button mat-menu-item disabled>
    <span class="flex flex-col leading-none">
      <span>{{ 'USER_MENU.SIGNED_IN_AS' | transloco }}</span>
      <span class="mt-1.5 text-md font-medium">
        {{ user?.name || 'N/A' }}
      </span>
    </span>
  </button>

  <mat-divider class="my-2"></mat-divider>

  <button mat-menu-item [routerLink]="profileLink" routerLinkActive="bg-gray-100">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>{{ 'USER_MENU.PROFILE' | transloco }}</span>
  </button>

  <mat-divider class="my-2"></mat-divider>

  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
    <span>{{ 'USER_MENU.SIGN_OUT' | transloco }}</span>
  </button>
</mat-menu>
